var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-7"},[_c('h4',{staticClass:"card-title"},[_vm._v("Bar Chart")]),_c('div',{staticClass:"mt-4"},[_c('div',[_c('vue-apex-charts',{attrs:{"type":"bar","height":"350","options":_vm.apexChartData.barChart.chartOptions,"series":_vm.apexChartData.barChart.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }